/** @format */

import React, { useEffect } from 'react';
import { Grid, FormControlLabel, Typography, Checkbox } from '@mui/material';
import { DatePicker } from 'components/LegacyPickers';
import { useFormContext } from 'react-hook-form';
import { InputV2, DatePickerPod, CustomCaptchaComponent, Icons, InputCurrency } from 'components';
import { useStyles } from './style';
import jMoment from 'moment-jalaali';
import UploadFiles from 'components/UploadFile';
import TypeAccountRadio from '../TypeAccountRadio';
import WalletOrCredit from '../WalletOrCredit';
import { CheckBoxIcon, CheckBoxIconFill } from 'components/CheckBox/CheckBoxIcon';
const BaseInfo = ({
  isGroup,
  setIsGroup,
  startDate,
  handleChangeStart,
  expireDate,
  handleChangeExpire,
  methodType,
  setMethodtype,
  setFile,
  setSelectCheckBox,
  selectCheckBox,
  balance,
  captchaFormRef,
  setCaptchaIdForm,
  setEnteredCaptchaForm,
  enteredCaptchaForm,
}) => {
  // -- HOOKS --//
  const methods = useFormContext();
  const { control, register, formState: { errors } } = methods;
  const classes = useStyles();

  useEffect(() => {
    handleChangeStart(jMoment(new Date().setHours(0, 0, 0, 0)));
    handleChangeExpire(jMoment(new Date().setHours(23, 59, 0, 0)).add(30, 'days'));
  }, []);

  // -- API REQUESTS --//
  return (
    <Grid container direction="row" alignItems="center" className={classes.root} item xs={12}>
      {/* Radio Options */}
      <Typography className={classes.bulkFileTitle}>
        <span className={classes.bulkFileIcon}>
          <Icons icon="users2" color="#667585" size="23" className={classes.bulkFileIcon} />
        </span>
        نوع تفویض وجه
      </Typography>

      {/* ردیو باتن تفویض تکی یا گروهی */}
      <TypeAccountRadio classes={classes} isGroup={isGroup} setIsGroup={setIsGroup} />
      {/* =============================================== */}
      <br />

      <WalletOrCredit
        balance={balance}
        methods={methods}
        methodType={methodType}
        setMethodType={setMethodtype}
      />
      {/*  Form Container */}
      {!isGroup ? (
        <Grid container style={{ marginTop: 8 }} spacing={1}>
          <Grid item xs={12} md={12} lg={12}>
            <FormControlLabel
              control={
                <Checkbox
                  defaultChecked
                  color="primary"
                  checked={selectCheckBox}
                  onChange={(e) => {
                    setSelectCheckBox(e.target.checked);
                  }}
                  icon={<CheckBoxIcon />}
                  checkedIcon={<CheckBoxIconFill />}
                />
              }
              label="وجه تفویض شده بابت کلیه تراکنش ها (خرید، انتقال وجه) قابل استفاده باشد."
            />
          </Grid>
          <Grid item xs={12} md={4} lg={3}>
            <InputV2
              fullWidth
              errors={errors}
              rules={['required', 'isNotContainTag']}
              label="تلفن‌همراه/ایمیل/نام‌کاربری مخاطب"
              name="contactInfo"
              register={register}
              control={control}
              englishNumber
              dir="ltr"
            />
          </Grid>
          <Grid item xs={12} md={4} lg={3}>
            <InputCurrency
              fullWidth
              errors={errors}
              rules={['required']}
              currency
              label="مبلغ"
              decimalPlaces={0}
              minimumValue={0}
              name="amount"
              register={register}
              control={control}
            />
          </Grid>
        </Grid>
      ) : (
        <>
          <br />
          <Grid item xs={12} style={{ marginTop: 2 * 8 }}>
            <Typography className={classes.bulkFileTitle}>
              <span className={classes.bulkFileIcon}>
                <Icons icon="file" color="#2B3990" size="18" />
              </span>
              فایل حاوی لیست تفویض وجه{' '}
              <a href="/files/sapmle-delegate-money-bymenu.xlsx" target="_blank" rel="noreferrer">
                دریافت فایل نمونه
              </a>
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            lg={6}
            style={{ marginTop: 16, marginInlineStart: -8, paddingRight: '8px' }}
          >
            <UploadFiles
              tooltip="فرمت فایل ارسالی به صورت xlsx می‌باشد."
              hasLink={false}
              setList={setFile}
              limitUpload={1}
              acceptsFile=".xlsx"
              type="MULTIPLE_TRANSACTION"
              acceptsList="xlsx"
            />
          </Grid>
        </>
      )}
      <Grid container style={{ marginTop: 8 }} spacing={1}>
        <Grid item xs={12} md={4} lg={3}>
          <DatePickerPod label="تاریخ شروع اعتبار" showAsterisk>
            <DatePicker
              variant="inline"
              autoOk
              inputVariant="outlined"
              showTodayButton
              todayLabel="امروز"
              okLabel="تایید"
              cancelLabel="لغو"
              clearLabel="پاک کردن"
              labelFunc={(date) => (date ? date?.format('jYYYY/jMM/jDD 00:00') : '')}
              rules={['required']}
              value={startDate}
              onChange={handleChangeStart}
              disablePast
            />
          </DatePickerPod>
        </Grid>
        {!isGroup ? (
          <Grid item xs={12} md={4} lg={3}>
            <DatePickerPod label="تاریخ انقضای اعتبار" showAsterisk>
              <DatePicker
                variant="inline"
                autoOk
                inputVariant="outlined"
                showTodayButton
                todayLabel="امروز"
                okLabel="تایید"
                cancelLabel="لغو"
                clearLabel="پاک کردن"
                labelFunc={(date) => (date ? date?.format('jYYYY/jMM/jDD 23:59') : '')}
                rules={['required']}
                value={expireDate}
                onChange={handleChangeExpire}
                disablePast
                {...(startDate ? { minDate: startDate } : null)}
              />
            </DatePickerPod>
            <span
              style={{ position: 'absolute', color: 'red', fontSize: '11px', marginTop: '-5px' }}
            >
              {methods?.errors?.expireDate?.message}
            </span>
          </Grid>
        ) : (
          <>
            <Grid container>
              <InputV2
                control={control}
                register={register}
                errors={errors}
                label="کد امنیتی"
                forceValue={enteredCaptchaForm}
                onChangeValue={(e) => {
                  const value = e.target.value;
                  if (value.length > 5) {
                    e.preventDefault();
                    setEnteredCaptchaForm(value.slice(0, 5));
                  } else {
                    setEnteredCaptchaForm(value);
                  }
                }}
                englishNumber
                rules={['isNumeric', 'required']}
                dir="ltr"
                name="captchaValue"
              />
              <CustomCaptchaComponent
                pageTitle="/Delegation - تفیض وجه -    فرم اصلی گروهی"
                ref={captchaFormRef}
                setCaptchaId={setCaptchaIdForm}
                setEnteredCaptcha={setEnteredCaptchaForm}
                sizeOptions={{ xs: '12', md: '10', lg: '10' }}
              />
            </Grid>
          </>
        )}
      </Grid>
    </Grid>
  );
};

export default BaseInfo;
